export type ImgComponentProps = {
  w: number;
  h: number;
  x: number;
  y: number;
};

const setPrevImgUrl = (imgUrl: string, props: ImgComponentProps) => {
  const myImgEvent = new CustomEvent('animatedImageAction', {
    detail: {
      url: imgUrl,
      props: props,
    },
  });

  document.dispatchEvent(myImgEvent);
};

const setNextImgUrl = (url: string, props: ImgComponentProps) => {
  const myImgEvent = new CustomEvent('animatedImageActionNew', {
    detail: {
      url: url,
      props: props,
    },
  });

  document.dispatchEvent(myImgEvent);
};

export const onClickImageHandler = (e: PointerEvent | any) => {
  //'any' used cuz if i specify like 'PointerEvent', i get an TS error for getting getBoundingClientRect() from eventTarget (but here target is HTMLImageElement which is unexpected for TS)
  const imgData = e.target.getBoundingClientRect();

  const imgProps: ImgComponentProps = {
    x: imgData.x,
    y: imgData.y,
    w: imgData.width,
    h: imgData.height,
  };
  const prevImgSrc = e.target?.currentSrc;
  if (prevImgSrc) setPrevImgUrl(prevImgSrc, imgProps);
};

export const onImageOnloadHandler = (imgComponent: HTMLImageElement) => {
  const nextImgSrc = imgComponent.currentSrc;
  const imgData = imgComponent.getBoundingClientRect();

  const imgProps: ImgComponentProps = {
    x: imgData.x,
    y: imgData.top,
    w: imgData.width,
    h: imgData.height,
  };

  setNextImgUrl(nextImgSrc, imgProps);
};

export const seamlessImageNavigation = (e: PointerEvent | MouseEvent, target?: HTMLElement) => {
  if (e.metaKey || e.ctrlKey) return;

  const imageHandlerProps = target || e.target;

  onClickImageHandler({ target: imageHandlerProps });
};
